<template>
  <div>
    <div class="editable-field" v-if="!editMode">
      <slot></slot>
      <a-button class="edit-icon" type="link" icon="edit" @click="enableEdit()"/>
    </div>
    <div v-else class="editable-field">
      <a-input v-model="newValue" type="text" :placeholder="placeholder" :disabled="loading" :value="value">
        <div slot="suffix">
          <a-button type="default" size="small" icon="close" :loading="loading" @click="editMode = false" style="margin-right: 4px"/>
          <a-button type="primary" size="small" icon="check" :loading="loading" @click="updateField()"/>
        </div>
      </a-input>
    </div>
  </div>
</template>

<script>
import httpClient from "../../utils/httpClient";

export default {
  name: "AccountFieldString",
  props: {
    value: {
      type: String,
      required: true
    },
    field: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: "Podaj wartość"
    },
    accountUuid: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      editMode: false,
      loading: false,
      newValue: ""
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(value) {
        this.newValue = value
      }
    }
  },
  methods: {
    enableEdit() {
      this.editMode = !this.editMode
    },

    updateField() {
      console.log(`Updating: ${this.field}, Value: `, this.newValue)
      this.loading = true
      httpClient.put(`/admin/accounts/details/${this.accountUuid}/update-field`, {
        field: this.field,
        value: this.newValue
      }).then(() => {
        this.$emit('updated', this.newValue)
        this.$message.success("Wartość została zaktualizowana!")
      }).catch(() => {
        this.$message.error("Wystąpił błąd aktualizacji pola!")
      }).finally(() => {
        this.editMode = false
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>
.editable-field .edit-icon {
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
}

.editable-field:hover .edit-icon {
  opacity: 1;
  display: inline-block;
}

.editable-field .ant-input-suffix {
  right: 5px;
}
</style>
